import * as angular from "angular";
import {IController} from "angular";

export class ContractsTableCtrl implements IController {

  queryString: string;
  infiniteScroll: any;
  accountId?: string
  sortType: string;
  isAddMode?: boolean;
  onViewContract: Function;
  onEditContractCarriers: Function;
  onContractDeleted: Function;
  onUnlinkContract: Function;
  onSetContractAsDefault: Function;
  onSortTypeChange: Function;
  onAdd: Function;

  public asceDescIconsMap;

  constructor() {
  }

  $onInit() {
    this.asceDescIconsMap = {
      asc: 'sort-asc',
      desc: 'sort-desc',
      undefined: 'sort'
    };
  }

}

angular
  .module('bringoz.admin.contracts')
  .component('contractsTable', {
    bindings: {
      infiniteScroll: '<',
      accountId: '<?',
      sortType: '<?',
      isAddMode: '<?',
      onViewContract: '&',
      onEditContractCarriers: '&',
      onContractDeleted: '&',
      onUnlinkContract: '&?',
      onSetContractAsDefault: '&',
      onSortTypeChange: '&',
      onAdd: '&'
    },
    template: require('./contracts-table.html').default,
    controller: ContractsTableCtrl
  });
